<!-- Loader starts-->
<div class="loader-wrapper"[class.loderhide]="!show">
  <img src="assets/1x/myRideLoader.gif" alt="" srcset="">
</div>
<!-- Loader ends-->